<template>
  <div>
    <div class="text-center piv">
      <label
        class="titrePage"
        style="font-size: 40px"
      >
        {{ $t("Panier.TitrePage") }} - {{ prenomNomEleve }}
      </label>
    </div>

    <v-img
      style="height: 100%"
      class="imageFond"
      :class="paddingSections()"
      :key="refreshAffichage"
    >
      <!-- Affichage d'une alerte d'erreur -->
      <v-alert
        v-model="afficherErreur"
        class="mb-0 text-center hyphen_auto"
        type="error"
        dismissible
        color="#CB381F"
        style="margin-right: 8%;margin-left: 8%;"
      >
        {{ messageErreur }}
      </v-alert>

      <!-- Affichage des 2 sections en même temps (lorsque les 2 listes ont au moins 1 élément) -->
      <div v-if="listeCoursPayes.length != 0 && listeCoursEnAttente.length != 0">
        <div class="flexPageConfirmation">
          <v-card
            style="margin-right:-50px;margin-top:20px"
            class="rounded-0 pa-7"
            elevation="0"
            :class="reductionCarte()"
          >
            <v-row style="height:60px">
              <v-col cols="12">
                <div>
                  <p style="font-size:18px">
                    <u>
                      <span style="font-weight: bold">{{$t("Paiement.listeInscriptionsPayees.titre")}}</span><br /><br />
                    </u>
                  </p>
                </div>
              </v-col>
            </v-row>
            <div
              v-if="infosChargees"
              :loading="!infosChargees"
            >
              <ListeInscriptionsPayees
                :listeCoursPayes="listeCoursPayes ?? []"
                :estUneSeuleSection="estUneSeuleSection"
                v-on:echecRemboursement="afficherAlerteErreur"
                v-on:peutPasPayer="afficherAlerteErreur"
              />
            </div>
            <div
              v-else
              style="text-align:center"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card>

          <v-card
            style="margin-top:20px"
            class="rounded-0 pa-7"
            elevation="0"
            :class="reductionCarte()"
          >
            <v-row style="height:60px">
              <v-col cols="12">
                <div>
                  <p style="font-size:18px">
                    <u>
                      <span style="font-weight: bold">{{$t("Paiement.listeInscriptionsListeAttente.titre")}}</span><br /><br />
                    </u>
                  </p>
                </div>
              </v-col>
            </v-row>
            <div
              v-if="infosChargees"
              :loading="!infosChargees"
            >
              <ListeInscriptionsListeAttente
                :listeCoursEnAttente="listeCoursEnAttente ?? []"
                :estUneSeuleSection="estUneSeuleSection"
                v-on:peutPasPayer="afficherAlerteErreur"
              />
            </div>
            <div
              v-else
              style="text-align:center"
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
          </v-card>
        </div>
      </div>
      <!-- Afficage d'une seule des 2 sections -->
      <div v-else>
        <v-img
          style="height: 100%"
          class="imageFond"
          :class="paddingSections()"
        >
          <div>
            <v-card
              style="margin-top:20px"
              class="rounded-0 pa-7"
              elevation="0"
              :class="reductionCarte()"
            >
              <v-row style="height:60px">
                <v-col cols="12">
                  <div>
                    <p style="font-size:18px">
                      <u>
                        <!-- Sélection du titre - Cours payés, else liste d'attente -->
                        <div v-if="listeCoursPayes.length != 0 && listeCoursEnAttente.length == 0">
                          <span style="font-weight: bold">
                            {{$t("Paiement.listeInscriptionsPayees.titre")}}
                          </span>
                        </div>
                        <div v-else-if="listeCoursPayes.length == 0 && listeCoursEnAttente.length != 0">
                          <span style="font-weight: bold">
                            {{$t("Paiement.listeInscriptionsListeAttente.titre")}}
                          </span>
                        </div>
                        <div v-else>
                          <span style="font-weight: bold">
                            {{$t("Paiement.listesVides.titre")}}
                          </span>
                        </div>
                        <br /><br />
                      </u>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <div
                v-if="infosChargees"
                :loading="!infosChargees"
              >
                <!-- Sélection de la liste - Cours payés, else liste d'attente -->
                <div v-if="listeCoursPayes.length != 0 && listeCoursEnAttente.length == 0">
                  <ListeInscriptionsPayees
                    :listeCoursPayes="listeCoursPayes ?? []"
                    :estUneSeuleSection="estUneSeuleSection"
                    :estUneSeuleSectionAvecPlusUnCours="estUneSeuleSectionAvecPlusUnCours"
                    v-on:echecRemboursement="afficherAlerteErreur"
                    v-on:peutPasPayer="afficherAlerteErreur"
                  />
                </div>
                <div v-else-if="listeCoursPayes.length == 0 && listeCoursEnAttente.length != 0">
                  <ListeInscriptionsListeAttente
                    :listeCoursEnAttente="listeCoursEnAttente ?? []"
                    :estUneSeuleSection="estUneSeuleSection"
                    :estUneSeuleSectionAvecPlusUnCours="estUneSeuleSectionAvecPlusUnCours"
                    v-on:peutPasPayer="afficherAlerteErreur"
                  />
                </div>
                <div v-else>
                  <!-- Rien dans les 2 listes -->
                  <v-col cols="12">
                    <v-card
                      outlined
                      class="pa-3 cardCours"
                      style="border: 2px solid #095797"
                    >
                      <v-card-title
                        class="aucunCoursDispo"
                        style="width:100%"
                      >
                        <p class="texteRienDansListes">
                          {{ $t('Paiement.listesVides.messageRienDansListes') }}
                        </p>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </div>
              </div>
              <div
                v-else
                style="text-align:center"
              >
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
            </v-card>
          </div>
        </v-img>
      </div>
    </v-img>

    <BoiteNousJoindre />
    <div class="petiteLigneBleue"></div>
    <LogiqueListes ref="logique" />
  </div>
</template>

<script>
import usePaiementStore from '@/store/paiementStore';
import useInscriptionStore from '@/store/inscriptionStore';
import BoiteNousJoindre from '../Accueil/BoiteNousJoindre.vue';
import ListeInscriptionsListeAttente from './ListeInscriptionsListeAttente.vue';
import ListeInscriptionsPayees from './ListeInscriptionsPayees.vue';
import { EtatCoursEleve } from '../../outils/Enum';

import LogiqueListes from './LogiqueListes.vue';

const selectionInscriptionLocalStorage = '_selectionInscription';
const racineLocalStorage = 'csqc_coursEte';

export default {
  name: 'ConfirmationPaiement',
  setup() {
    const paiementStore = usePaiementStore();
    const inscriptionStore = useInscriptionStore();

    return { paiementStore, inscriptionStore };
  },
  components: {
    BoiteNousJoindre,
    ListeInscriptionsListeAttente,
    ListeInscriptionsPayees,
    LogiqueListes,
  },
  data() {
    return {
      NumFacture: '',
      estMobile: false,
      listeCoursPayes: [],
      listeCoursEnAttente: [],
      infosChargees: false,
      chargementCours: false,
      estUneSeuleSection: false,
      refreshAffichage: 0,
      sectionPayeesPlusUnCours: false,
      sectionAnnuleesPlusUnCours: false,
      estUneSeuleSectionAvecPlusUnCours: false,
      afficherErreur: false,
      messageErreur: '',
      estAnnuleParParents: EtatCoursEleve.AnnulerParParent,
      estAnnuleParCSS: EtatCoursEleve.AnnulerParCSS,
      prenomNomEleve: '',
      estEnAttentePaiement: EtatCoursEleve.EnAttentePaiement,
    };
  },
  async created() {
    // Lorsqu'un cours est payé, on refresh les données de la page pour avoir les données les plus récentes dans le frontend
    this.rafraichissementDonnees();

    this.definirOrganisme();
    this.infosChargees = false; // Chargement débuté (aussi mis dans definirCoursListe au cas)

    this.NumFacture = this.$route.params.numfacture;
    if (window.screen.width <= 760) {
      this.estMobile = true;
    } else {
      this.estMobile = false;
    }
  },
  methods: {
    reductionCarte() {
      // Desktop + les 2 sections
      if (!this.estMobile && !this.estUneSeuleSection) {
        return 'reductionCarte';
      }

      // Mobile ou 1 section avec plus d'un cours
      if (this.estMobile || (this.estUneSeuleSection && (this.sectionPayeesPlusUnCours || this.sectionAnnuleesPlusUnCours))) {
        return 'reductionMobile';
      }

      // Desktop + 1 seule section
      return 'reductionUnSeulCoursPageConfirmation';
    },
    paddingSections() {
      if (!this.estMobile) {
        return 'paddingSectionsPageConfirmation';
      }
      return '';
    },
    async definirCoursListes() {
      // Préparation des infos
      this.infosChargees = false;
      this.listeCoursPayes = [];
      this.listeCoursEnAttente = [];

      // Obtention des cours de l'élève + les coursEleve selon le GUID de la page de confirmation
      const guidDeURL = this.$route.params.guid;
      await this.paiementStore.definirIdEleveSelonGuid(guidDeURL);
      const { idEleve } = this.paiementStore;
      this.inscriptionStore.eleveId = idEleve;
      await this.paiementStore.eleveDefinirCours(idEleve);
      await this.paiementStore.eleveDefinirCoursEleve(idEleve);
      const cours = this.paiementStore.coursPageConfirmation;

      const coursEleve = this.paiementStore.coursElevePageConfirmation;

      // Obtention du nom de l'élève pour l'afficher
      await this.paiementStore.obtenirEleve(idEleve);
      this.definirOrganisme(this.paiementStore.eleve.eleveEcoles[0] ? this.paiementStore.eleve.eleveEcoles[0].provenanceEleve : 0);
      this.prenomNomEleve = this.paiementStore.eleve.eleveNom;

      // Mise en place de l'affichage des cours dans les  bonnes sections
      if (cours == null || cours.length === 0) {
        // Pas de cours
        this.listeCoursPayes = [];
        this.listeCoursEnAttente = [];
      } else {
        // Recherche des cours + affectation dans la  bonne liste
        for (let cpt = 0; cpt < cours.length; cpt += 1) {
          // Si le cours est null, le skip
          if (cours[cpt] == null) {
            // eslint-disable-next-line no-continue
            continue;
          }

          const coursEleveSelonCours = coursEleve.filter((x) => x.coursId === cours[cpt].id);

          // Définition des transactions, set des id + obtention dans le backend
          const coursEleveIdPourTransactions = [];
          for (let cptT = 0; cptT < coursEleveSelonCours.length; cptT += 1) {
            coursEleveIdPourTransactions.push(coursEleveSelonCours[cptT].id);
          }
          // eslint-disable-next-line no-await-in-loop
          const transactions = await this.definirTransactions(coursEleveIdPourTransactions);

          for (let cpt2 = 0; cpt2 < coursEleveSelonCours.length; cpt2 += 1) {
            // Suppression de coursId pour éviter un problème de clés dupliquées.
            delete coursEleveSelonCours[cpt2].coursId;
            // delete cours[cpt].id; TODO: Vérifier si c'est nécessaire de le delete car produit des call étrange

            // Validations et données
            let remboursement = null;
            if (transactions !== undefined) {
              // TODO: Code à améliorer dans une future année. Au lieu de matcher par compteurs, faudrait idéalement utiliser .find() sauf que les transactions ne contiennent pas directement le coursEleveId pour faire ça
              remboursement = transactions[cpt2] != null ? transactions[cpt2].montant : null;
            }
            const { estListeAttente } = coursEleveSelonCours[cpt2];
            const { estGratuit } = coursEleveSelonCours[cpt2];
            const estAnnuleParParentOuParCSS = coursEleveSelonCours[cpt2].etat === (this.estAnnuleParParents || this.estAnnuleParCSS);
            const estEnAttentePaiement = coursEleveSelonCours[cpt2].etat === this.estEnAttentePaiement;

            // Si c'est en attente de paiement, on le passe pour ne pas l'affecter dans une des deux listes. La boucle continue par la suite.
            if (estEnAttentePaiement) {
              // eslint-disable-next-line no-continue
              continue;
            }

            // Affectation dans la liste
            if ((!estListeAttente && !estAnnuleParParentOuParCSS) || remboursement != null) {
              this.listeCoursPayes.push({
                cours: cours[cpt],
                coursEleve: coursEleveSelonCours[cpt2],
                remboursement,
                estGratuit,
                demandeDeChangementDeCoursEnCours: coursEleveSelonCours[cpt2].changementDeCours === 0, // Si c'est 0, une demande de changement de cours est active
              });
            } else {
              this.listeCoursEnAttente.push({ cours: cours[cpt], coursEleve: coursEleveSelonCours[cpt2], estGratuit });
            }
          }
        }
      }

      // Déterminer les sections
      if (this.listeCoursPayes.length > 1 && this.listeCoursEnAttente.length === 0) {
        this.sectionPayeesPlusUnCours = true;
      } else if (this.listeCoursPayes.length === 0 && this.listeCoursEnAttente.length > 1) {
        this.sectionAnnuleesPlusUnCours = true;
      }

      // Si c'est une seule section avec plus d'un cours, la prop devient true
      if ((this.sectionPayeesPlusUnCours && !this.sectionAnnuleesPlusUnCours) || (!this.sectionPayeesPlusUnCours && this.sectionAnnuleesPlusUnCours)) {
        this.estUneSeuleSectionAvecPlusUnCours = true;
      }

      // Déterminer si c'est une seule section ou non
      if (this.listeCoursPayes.length > 0 && this.listeCoursEnAttente.length > 0) {
        this.estUneSeuleSection = false;
      } else {
        this.estUneSeuleSection = true;
      }
      this.infosChargees = true; // Chargement fini
    },
    afficherAlerteErreur(messageErreur) {
      this.messageErreur = messageErreur;
      this.afficherErreur = true;
      setTimeout(() => {
        this.afficherErreur = false;
      }, 10000);
    },
    rafraichissementDonnees() {
      this.listeCoursEnAttente = [];
      this.listeCoursPayes = [];
      this.definirCoursListes();
      this.refreshAffichage += 1;
      this.paiementStore.rafraichissementDonneesNecessaire = false;
    },
    async definirTransactions(listeCoursEleveId) {
      // Quand la page de confirmation est atteinte en spammant le back button de la page web, il se peut que this.$refs.logique soit undefined
      if (this.$refs.logique != null) {
        const transactions = await this.$refs.logique.definirTransactions(listeCoursEleveId);
        return transactions;
      }
      return null;
    },
    definirOrganisme(organisme) {
      if (organisme != null) {
        const valeurSelectionInscription = localStorage.getItem(racineLocalStorage + selectionInscriptionLocalStorage);
        if (valeurSelectionInscription === null) {
          localStorage.setItem(`${racineLocalStorage}${selectionInscriptionLocalStorage}`, organisme);
        }
      }
    },
  },
  computed: {
    rafraichissementDonneesNecessaire() {
      return this.paiementStore.rafraichissementDonneesNecessaire;
    },
  },
  watch: {
    // Lors d'une annulation par le parent
    rafraichissementDonneesNecessaire() {
      if (this.paiementStore.rafraichissementDonneesNecessaire === true) {
        this.rafraichissementDonnees();
      }
    },
  },
};
</script>

<style scoped>
.reductionMobile {
  width:97%; /* Mettre 3% de moins compense pour le margin-right qui ne faisait rien */
  margin-top:20px;
  margin-bottom: 20px;
  margin-left: 5px;
}

.texteRienDansListes {
  width: inherit;
  text-align: center;
  margin-bottom: 0;
}
</style>
